import { AppSettings } from '../constants';
import { REFRESHING_TOKEN } from './constants';
import moment from 'moment';
import JWT from 'helper/interceptors';
import { connect } from 'react-redux';
import * as AuthActionType from '../Auth/constants';

class Auth {
  static loggedIn() {
    return (
      !!localStorage[AppSettings.S1_TOKEN] ||
      !!localStorage[AppSettings.S1_REFRESH_TOKEN]
    );
  }

  static setAuth(token, uid, refresh, expires, roleName,IsSSOUser,logoUrl,ReferrerClientUrl, ssoClientRedirectUrl,{ ...others }) {
    localStorage.setItem(AppSettings.S1_TOKEN, token);
    localStorage.setItem(AppSettings.S1_UID, uid);
    localStorage.setItem(AppSettings.S1_REFRESH_TOKEN, refresh);
    localStorage.setItem(AppSettings.S1_EXPIRES_TIME, expires);
    localStorage.setItem(AppSettings.S1_TOKEN_CREATED, moment().unix());
    localStorage.setItem(AppSettings.S1_ROLE_NAME, roleName);
    localStorage.setItem(AppSettings.S1_SSO, others.sso);
    localStorage.setItem(AppSettings.IS_SSO_USER,IsSSOUser);
    localStorage.setItem(AppSettings.CUSTOM_LOGO_URL,logoUrl);
    localStorage.setItem(AppSettings.S1_REDIRECT_CLIENT_URL,ReferrerClientUrl);
    localStorage.setItem(AppSettings.S1_REDIRECT_CLIENT_LOGIN_URL,ssoClientRedirectUrl);

    if (others.callback) {
      others.callback();
    }
  }
  static updateToken(token, refresh, expires) {
    localStorage.setItem(AppSettings.S1_TOKEN, token);
    localStorage.setItem(AppSettings.S1_REFRESH_TOKEN, refresh);
    localStorage.setItem(AppSettings.S1_EXPIRES_TIME, expires);
    localStorage.setItem(AppSettings.S1_TOKEN_CREATED, moment().unix());
  }

  static logOut() {
    localStorage.removeItem(AppSettings.S1_TOKEN);
    localStorage.removeItem(AppSettings.S1_UID);
    localStorage.removeItem(AppSettings.S1_REFRESH_TOKEN);
    localStorage.removeItem(AppSettings.S1_EXPIRES_TIME);
    localStorage.removeItem(AppSettings.S1_TOKEN_CREATED);
    localStorage.removeItem(AppSettings.S1_ROLE_NAME);
    localStorage.removeItem(AppSettings.S1_USER_EMAIL);
    localStorage.removeItem('izendaToken');
    localStorage.removeItem(AppSettings.IS_SSO_USER);
    localStorage.removeItem(AppSettings.CUSTOM_LOGO_URL);
    localStorage.removeItem(AppSettings.S1_REDIRECT_CLIENT_URL);
    localStorage.removeItem(AppSettings.S1_REDIRECT_CLIENT_LOGIN_URL); }

  static getRoleName() {
    return localStorage[AppSettings.S1_ROLE_NAME];
  }
}

export function refreshToken(dispatch) {
  var refresh = localStorage[AppSettings.S1_REFRESH_TOKEN];
  var freshTokenPromise = JWT(AppSettings.CURRENT_SITE_URI)
    .get(`/oauth/refresh-token/${refresh}`, null, 'GET')
    .then(t => {
      var data = t.data;
      if (process.env.NODE_ENV === 'development') {
        console.log(data);
      }

      Auth.updateToken(data.access_token, data.refresh_token, data.expires_in);
      if (data.access_token) {
        return Promise.resolve(data.access_token);
      }
      Auth.logOut();
      return Promise.reject({
        message: 'could not refresh token'
      });
    })
    .catch(e => {
      // Auth.logOut();
      // // console.log('error refreshing token', e);
      // location.href = '/sign-in';
      // // return Promise.reject(e);
      // console.log('Refresh token API error..refreshing page.')
      // // window.location.reload();
      const isExternalSSOUser = localStorage.getItem(AppSettings.IS_SSO_USER);
      if(isExternalSSOUser === "True" || isExternalSSOUser === true){
          dispatch({
            type: AuthActionType.LOGOUT,
            params:null,
            callback:()=>{
              let removeWww = localStorage[AppSettings.S1_REDIRECT_CLIENT_URL];
              let referrerClientUrl = removeWww.replace(/www./,'');              
              Auth.logOut();
              // Check if http or https available
              let pattern = /^((http|https):\/\/)/;
              if(!pattern.test(referrerClientUrl)) {
                referrerClientUrl = `${window.location.protocol + "//"}${referrerClientUrl}`;
              }

              location.href = isExternalSSOUser === 'True' || isExternalSSOUser === true ? referrerClientUrl : '/sign-in';
              }});
      }else{    
        Auth.logOut();
        location.href = '/sign-in'
      }
    });

  dispatch({
    type: REFRESHING_TOKEN,
    // we want to keep track of token promise in the state so that we don't try to refresh
    // the token again while refreshing is in process
    freshTokenPromise
  });

  return freshTokenPromise;
}

export function jwtMiddleware({ dispatch, getState }) {
  return next => action => {
    // only worry about expiring token for async actions
    if (action && action.type && action.type !== REFRESHING_TOKEN) {
      //   // decode jwt so that we know if and when it expires
      var expires = localStorage[AppSettings.S1_EXPIRES_TIME];
      var tokenCreated = localStorage[AppSettings.S1_TOKEN_CREATED];
      var token_refresh = localStorage[AppSettings.S1_REFRESH_TOKEN];
      var token = localStorage[AppSettings.S1_TOKEN];
      var today = moment().unix();
      if (
        (!token && !!token_refresh) ||
        (!!token_refresh &&
          tokenCreated &&
          Number(today) - Number(tokenCreated) > Number(expires) - 5000)
      ) {
        if (process.env.NODE_ENV === 'development') {
          console.log('begin refresh token');
        }

        // make sure we are not already refreshing the token
        if (!getState().authReducer.freshTokenPromise) {
          return refreshToken(dispatch).then(() => next(action));
        } else {
          return getState().authReducer.freshTokenPromise.then(() =>
            next(action)
          );
        }
      }
    }

    return next(action);
  };
}

const mapStateToProps = state => {
  return {
    user: state.authReducer.user
  };
};

export default connect(mapStateToProps)(Auth);



// WEBPACK FOOTER //
// ./src/Auth/authenticator.js